import StreamTitle from "components/common/markdown/StreamTitle";
const entityLinkResolvers = [
  {
    uriSegment: "streams",
    resolve: ([id]) => id ? { grnType: "stream", id, Title: StreamTitle } : null
  }
];
export default entityLinkResolvers;
